import React, {useEffect, useRef, useState} from "react";
import {Container} from "./styles";
import IconTarget from "../../assets/icons/target.svg";
import {routesTechnologiesMap} from "./index.const";
import {useLocation, useNavigate} from "react-router-dom";
import {Dropdown, DropdownButton} from "react-bootstrap";
import {ITypeRadar} from "../../types";
import {SearchInputCustom} from "../../ui/SearchInputCustom";
import useFetchDataEsgLayers from "../../hooks/useFetchDataEsgLayers";
import {apiKeyDataEsg, urlApiDataEsg} from "../../helper/api";
import {Iroute} from "./index.type";
import {useQueryParam} from "../../hooks/useQueryParamEsg";
import {useAuthStatus} from "../../hooks/useAuthStatus";

interface IProps {
  typeRadar?: ITypeRadar;
  isLogin?: boolean;
}
const TechnologiesMap: React.FC<IProps> = ({typeRadar, isLogin}) => {
  const navigate = useNavigate();
  const location = useLocation();

  const currentUrl = location.pathname.slice(1);
  const idEsg = useQueryParam("id");
  const goToUrl = (url: string) => {
    // const url = event.target.value;
    if (url === "kartaTechnologies") {
      navigate(`/`);
    } else {
      navigate(`/${url}`);
    }
  };

  const [listMenuUrls, setListMenuUrls] = useState<Iroute[]>(
    routesTechnologiesMap
  );
  const [listFindUrls, setListFindUrls] = useState<Iroute[]>(
    routesTechnologiesMap
  );
  const searchInputRef = useRef<HTMLInputElement>(null);
  const [inputSearchValue, setInputSearchValue] = useState("");

  const apiUrlLayers = `${urlApiDataEsg}/api/layers`;
  if (!apiKeyDataEsg) {
    throw new Error("API key не тот");
  }

  const {layersData} = useFetchDataEsgLayers(apiUrlLayers, apiKeyDataEsg);

  useEffect(() => {
    if (layersData && Array.isArray(layersData.data)) {
      const updatedRoutes = routesTechnologiesMap.map((item) => {
        if (item.page === "esg") {
          const childs = layersData.data.map((layer) => ({
            id: `${layer.documentId}`.toLowerCase(),
            title: String(layer.name),
            disabled: false,
          }));
          return {
            ...item,
            childs,
          };
        }
        return item;
      }) as Iroute[];
      setListMenuUrls(updatedRoutes);
    }
  }, [layersData]);

  const handleTypeSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    setInputSearchValue(event.target.value);
  };

  useEffect(() => {
    if (listMenuUrls.length === 0 || !inputSearchValue) {
      setListFindUrls(
        listMenuUrls.length > 0 ? listMenuUrls : routesTechnologiesMap
      );
    } else {
      const search = inputSearchValue.toLowerCase();
      const resultChange = listMenuUrls
        .map((item) => {
          if (item.title.toLowerCase().includes(search)) {
            return item;
          }
          if (item.childs) {
            const filteredChilds = item.childs.filter((child) =>
              child.title.toLowerCase().includes(search)
            );
            if (filteredChilds.length > 0) {
              return {...item, childs: filteredChilds};
            }
          }
          return null;
        })
        .filter(Boolean) as Iroute[];
      setListFindUrls(resultChange);
    }
  }, [inputSearchValue, listMenuUrls]);

  const getCurrentPageFromUrl = () => {
    if (currentUrl === "") return "kartaTechnologies";
    if (currentUrl === "finTech") return "finTech";
    if (currentUrl === "weakSignals") return "weakSignals";
    if (currentUrl === "state_initiative") return "state_initiative";
    if (currentUrl === "crgci_organizations") return "crgci_organizations";
    if (currentUrl === "esg") return "esg";
    return currentUrl;
  };

  const currentPage = getCurrentPageFromUrl();

  const title = routesTechnologiesMap.find(
    (route) => route.page === currentPage
  )?.title;

  return (
    <>
      <Container>
        {/* <ImageWrapper>
        <img src={MapCircleIcon} alt="Circle" />
      </ImageWrapper> */}
        <DropdownButton
          title={
            <div style={{display: "flex", alignItems: "center", gap: 10}}>
              <img src={IconTarget} alt={"alt"} />
              {title || "Карта технологий"}
              {typeRadar === "esg" && listFindUrls.length > 0 && (
                <span>
                  {" —  "}
                  {
                    listFindUrls
                      .find((route) => route.page === "esg")
                      ?.childs?.find((child) => child.id === idEsg)?.title
                  }
                </span>
              )}
            </div>
          }
          className="custom-dropdown-button"
        >
          <div
            style={{
              padding: "0 10px",
              color: "rgba(255, 255, 255, 0.3)",
              fontSize: "14px",
            }}
          >
            <div>
              <SearchInputCustom
                searchInputRef={searchInputRef}
                inputSearchValue={inputSearchValue}
                handleTypeSearch={handleTypeSearch}
                setInputSearchValue={setInputSearchValue}
                placeholder="Найти радар"
              />
            </div>
            Все радары
          </div>
          {listFindUrls &&
            listFindUrls.map((route) => {
              if (route.page === "crgci_organizations" && !isLogin) {
                return null;
              }
              if (route.page === "esg") {
                return route.childs?.map((child) => {
                  return (
                    <Dropdown.Item
                      key={child.id}
                      onClick={() => goToUrl(`${route.page}?id=${child.id}`)}
                    >
                      <div
                        className="custom-form-control-label"
                        style={{
                          color: idEsg === child.id ? "#fff" : "#57BCFF",
                          fontWeight: "600",
                        }}
                      >
                        ESG - {child.title} {idEsg === child.id && "(Вы тут)"}
                      </div>
                    </Dropdown.Item>
                  );
                });
              } else {
                return (
                  <Dropdown.Item
                    key={route.page}
                    onClick={() => goToUrl(route.page)}
                  >
                    <div
                      className="custom-form-control-label"
                      style={{
                        color: currentPage === route.page ? "#fff" : "#57BCFF",
                        fontWeight: "600",
                      }}
                    >
                      {route.title} {currentPage === route.page && "(Вы тут)"}
                    </div>
                  </Dropdown.Item>
                );
              }
            })}
        </DropdownButton>
      </Container>
    </>
  );
};

export default TechnologiesMap;
